import { LicenseInfo } from '@mui/x-license-pro';
const applyLicense = () => LicenseInfo.setLicenseKey('f204438fcb474b0274c61cc3c83cf0e0T1JERVI6NDM1MjAsRVhQSVJZPTE2ODM4ODk5NDkwMDAsS0VZVkVSU0lPTj0x');
export default applyLicense;